module.exports = __webpack_public_path__ + "static/media/logo-vaneau-white.4040d153.svg";